import { DEFAULT_DATE_FORMAT, DEFAULT_PARSE_FORMAT, isNotDefined } from '@enterprise/core';
import { DateFormat } from '@enterprise/ui';

import type { DateCellRendererParams } from './types/date-cell-renderer.params';

function DateCellRenderer<TData = Record<string, unknown>, TContext = unknown>({
  node,
  showTotal = true,
  value,
}: DateCellRendererParams<TData, TContext>) {
  const isRootLevel = node.level === -1;

  if (isNotDefined(value) && isRootLevel && showTotal) {
    return 'Total';
  }

  if (isNotDefined(value)) {
    return null;
  }

  return (
    <DateFormat
      format={{
        format: DEFAULT_DATE_FORMAT,
        parseFormat: DEFAULT_PARSE_FORMAT,
      }}
      value={value}
    />
  );
}

export default DateCellRenderer;
